import { SubsidizedMortgageContainer } from '../SubsidizedMortgageContainer';
import { LinkButton, useDeviceType } from '@cian/ui-kit';

import * as styles from './styles.css';
import { useApplicationContext } from '../../../common/utils/applicationContext';
import { useSelector } from 'react-redux';

import { ETestIds } from '../../constants/testIds';
import { selectCalculatorValues } from '../../selectors/selectCalculatorValues';
import { ERuntimeSettings } from '../../../common/types/runtimeSettings';

export interface IButtonConfig {
  text: string;
  width: number;
  baseUrl: string;
}

/**
 * TODO: в будущем - убрать ширину кнопки
 * до тех пор, пока нет макетов, невозможно ее предсказать поэтому вынесена в RS
 * */

export const SubsidizedMortgageContainerWithBtn = () => {
  const isDesktop = useDeviceType() === 'desktop';
  const { config } = useApplicationContext();
  const btnConfig = config.get<IButtonConfig>(ERuntimeSettings.linkButtonConfig);
  const { term, price, additionalQueryString } = useSelector(selectCalculatorValues);

  return (
    <div className={styles['root']}>
      <SubsidizedMortgageContainer />
      <div style={{ width: isDesktop ? btnConfig?.width : /* istanbul ignore next */ 'auto' }}>
        <LinkButton
          size={'L'}
          href={`${btnConfig?.baseUrl}?term=${term}&price=${price}&${additionalQueryString && additionalQueryString}`}
          fullWidth
          target="_parent"
          data-testid={ETestIds.LinkButton}
        >
          {btnConfig?.text}
        </LinkButton>
      </div>
    </div>
  );
};
